module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABIElEQVQ4T5WTfVEDQQxHXx0gARQACigOwEFRAA4KCkoVgARQAFVAUQAScEDn7SQ34XrbGfLPfWTzkvySndG3I+At3JfAz9TR2QHAPTAP/zvg9571AGb/Aq4j4gU4nqqiB8jsWcEWELJXxRhwBpwCj8BNBFnEAlgG4BMQ2EzAFXBb+t3EgbtRw0JNcBH/hawF/AIPkW0gHxBXlyDbWwl4jrK7o5qA5Yg3qcF/IGZ/AtRiUUVMiKP77rRgsMv1GsI2EaupgWIJmzKnobiChinUgwp6Xsc0oiicFQyJawVSP6oTUCyt3gOTnGSbFeA+uGmCDHQ3chdsax0g9bEV78cfDQx2SXQYqMq5uj5zQ02kiM03bsFghdTZMhSz/6zQ97Z0O8uGPwCWNma7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/star.png
// module id = zlqU
// module chunks = 1